export default "__VITE_ASSET__BxyrvIZT__"